// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"widthPicker_popupContainer__CadiJ","btn":"widthPicker_btn__VJyxW"};